module.exports = __webpack_public_path__ + "static/husek-e486d997e2707de060f2c5b32c4a8e02.jpg";